import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import axios from "../src/configuration/axios";
import { useMsal } from "@azure/msal-react";
import FulfillmentPage from "./pages/FulfillmentPage";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Routes,
} from "react-router-dom";
import MainPage from "./pages/MainPage";
import UserManagementPage from "./pages/UserManagementPage";
import LicenseMangementPage from "./pages/LicenseManagementPage";
import { Text } from "@fluentui/react";

function App() {
  const { instance, accounts, inProgress } = useMsal();
  const [hasAdminSignedInAndSubscription, setHasAdminSignedInAndSubscription] =
    useState(false);
  const [hasAdminRights, setHasAdminRights] = useState(false);
  const [userSignedIn, setUserSignedIn] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);
  const [tenantHasSubscription, setTenantHasSubscription] = useState(undefined);
  let authMsalToken = localStorage.getItem("msalToken");
  let interval;
  useEffect(() => {
    if (!localStorage.getItem("msalToken")) {
      setTokenExpired(true);
    }
    interval = setInterval(() => {
      if (!localStorage.getItem("msalToken")) {
        setTokenExpired(true);
      }
    }, 30000);
  }, []);

  useEffect(() => {
    checkSignedInAndAdminRights();
  }, [hasAdminRights, userSignedIn, tenantHasSubscription]);
 const getAllData = () => {
   
 }
  function checkSignedInAndAdminRights() {
    if (
      hasAdminRights === true &&
      userSignedIn === true &&
      tenantHasSubscription
    ) {
      setHasAdminSignedInAndSubscription(true);
      return true;
    } else {
      setHasAdminSignedInAndSubscription(false);
      return false;
    }
  }

  useEffect(async () => {
    await isLoggedIn();
    if (userSignedIn) {
      await checkTenantHasSubscription();
    }
  }, [userSignedIn, accounts, tenantHasSubscription]);

  async function isLoggedIn() {

    if (authMsalToken) {
      setUserSignedIn(true);
      await checkTenantHasSubscription();
    } else {
      setUserSignedIn(false);
    }
  }


  async function checkTenantHasSubscription() {
    if (accounts.length > 0) {
      var resultData;
      var tenantId = accounts[0].tenantId;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + authMsalToken;

      await axios
        .get(
          axios.defaults.baseURL + "/Subscription/CheckSubscriptionByTenantId",
          { params: { tenantId: tenantId } }
        )
        .then((result) => {
          setTokenExpired(false);
          setTenantHasSubscription(result.data);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });

      await checkAdminRights();
    }
  }

  async function checkAdminRights() {
    if (accounts.length > 0) {
      var resultData;
      var tenantId = accounts[0].tenantId;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
        },
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("msalToken");

      if(tenantHasSubscription)  
      await axios
        .get(
          axios.defaults.baseURL + "/Subscription/GetByTenantId",
          {
            params: { tenantId: tenantId },
          }
        )
        .then(async (result) => {
          resultData = result.data;
          await getAdminRights(resultData.id, accounts[0].username).catch(
            (error) => {
              if (error.response.status === 401) {
                setTokenExpired(true);
              }
            }
          );
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
    }
  }

  async function getAdminRights(subscriptionId, userEmail) {
    if (accounts.length > 0 && subscriptionId !== undefined) {
      var resultData;
      var userEmail = accounts[0].username;

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("msalToken");

      await axios
        .get(
          axios.defaults.baseURL+ "/LicenseManager/IsAdmin",
          {
            params: { subscriptionId: subscriptionId, userEmail: userEmail },
          }
        )
        .then((result) => {
          setTokenExpired(false);
          setHasAdminRights(result.data);
          resultData = result.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
    }
  }

  return (
    <Router>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <MainPage
              setTokenExpired={setTokenExpired}
              tokenExpired={tokenExpired}
              hasAdminRights={hasAdminRights}
              setHasAdminRights={setHasAdminRights}
              userSignedIn={userSignedIn}
              setUserSignedIn={setUserSignedIn}
              tenantHasSubscription={tenantHasSubscription}
              setTenantHasSubscription={setTenantHasSubscription}
              getAllData={getAllData}
            />
          }
        />
        <Route
          exact
          path="/fulfillment"
          element={
            <FulfillmentPage
              setTokenExpired={setTokenExpired}
              tokenExpired={tokenExpired}
              hasAdminSignedInAndSubscription={hasAdminSignedInAndSubscription}
            />
          }
        />
        <Route
          exact
          path="/usermanagement"
          element={
            <UserManagementPage
              setTokenExpired={setTokenExpired}
              tokenExpired={tokenExpired}
              hasAdminSignedInAndSubscription={hasAdminSignedInAndSubscription}
            />
          }
        />
        <Route
          exact
          path="/licensemanagement"
          element={
            <LicenseMangementPage
              setTokenExpired={setTokenExpired}
              tokenExpired={tokenExpired}
              hasAdminSignedInAndSubscription={hasAdminSignedInAndSubscription}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
